import React from "react";
import "./error.scss";

export default () => <div className="error">Sorry, Page Not Found</div>;
